import { useCallback } from 'react'

import CloseIcon from '@/assets/icons/icon-close.svg'
import { Tooltip } from '@/components/ui/tooltip'
import type { ScriptNode } from '@/modules/scripts/types'

interface Props {
  item: ScriptNode
  onRemove: (i: ScriptNode) => void
}

export const ChatScriptTag = ({ item, onRemove }: Props) => {
  const handleRemove = useCallback(() => {
    onRemove(item)
  }, [item, onRemove])

  return (
    <Tooltip content="Marks this script as sent for the selected fan.">
      <div
        className="flex h-fit items-center rounded-2xl bg-primary-10 p-1 px-2 last:mr-0 dark:bg-primary-900"
        data-testid="script-tag"
      >
        <span className="mr-2 text-sm font-medium">Sent Marker</span>
        <CloseIcon
          onClick={handleRemove}
          className="cursor-pointer transition hover:text-primary-500"
        />
      </div>
    </Tooltip>
  )
}
